import { preloadImage } from "@/utils/helpers"
import { useEffect } from "react"

export function ImageComponent(props: {
  src: string
  className?: string
  alt?: string
}) {
  useEffect(() => {
    try {
      preloadImage(props.src).then(() => console.log("Image preloaded"))
    } catch (error) {
      console.error("There was an error:", error)
    }
  }, [props.src])

  return (
    <img
      src={props.src}
      className={props.className}
      alt={props.alt}
      onError={(e) => {
        e.currentTarget.src = "/cars/hero.avif"
      }}
    />
  )
}
